// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1551":"82201128","5283":"4e644f54"}[chunkId] + ".chunk.css";
};